import React from "react";
import { Link } from "react-router-dom";
import { getTime } from "../../utilities/date";

import { AnnouncementProps } from "./Announcements";

interface Props {
    announcement: AnnouncementProps;
}

const Announcement: React.FC<Props> = ({ announcement }) => {
    // Get date
    let created: Date = new Date(announcement.created);

    return (
        <div className="w-100 px-2 py-1">
            <div className="box-shadow">
                <div className="title-bar px-2">
                    <Link
                        to={"/forum/topic/" + announcement.slug}
                        className="title-navigation-link text-white"
                    >
                        <span>
                            {announcement.title} -{" "}
                            {created.toLocaleDateString([], {
                                year: "numeric",
                                month: "long",
                            })}
                        </span>
                    </Link>
                </div>
                <div className="bg-light-gray p-2 bl-xs br-xs bb-xs d-flex flex-column">
                    <span className="font-weight-bold mb-2">
                        On {getTime(created)},{" "}
                        {created.toLocaleDateString([], {
                            weekday: "long",
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                        })}
                        , {announcement.author} wrote:
                    </span>

                    <div
                        className="dangerous-container"
                        dangerouslySetInnerHTML={{
                            __html: announcement.content,
                        }}
                    />

                    <span className="mt-2 text-muted">
                        Replies: {announcement.replies} <br />
                        Views: {announcement.views}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default Announcement;
